import EEnvironmentVariables from '~/models/config'

export enum EHttpService {
  amplify = 'amplify',
  partner = 'partner',
  campaigns = 'campaigns',
  scenarios = 'scenarios',
  agent = 'agent',
}

export const httpServicesBaseUrl = {
  [EHttpService.amplify]: null,
  [EHttpService.partner]: import.meta.env[
    EEnvironmentVariables.VITE_PARTNER_SERVICE
  ],
  [EHttpService.agent]: import.meta.env[
    EEnvironmentVariables.VITE_AGENT_SERVICE
  ],
}

export enum EMarketingClientPath {
  home = '/',
  examplePage = '/example-page',
  faq = '/faq',
  homeAppointment = '/appointment',
  homeGym = '/gym',
  about = '/about',
  marketingIntegrations = '/help/integrations',
  marketingPrivacyPolicy = '/help/privacy-policy',
  marketingTermsOfUse = '/help/terms-of-use',
  marketingReferralsTerms = '/help/referrals-terms',
  whoWeHelpGym = '/who-we-help/gym-and-studio',
  whoWeHelpSpas = '/who-we-help/spas-and-wellness-centers',
  whoWeHelpMartialArtsDanceMovement = '/who-we-help/martial-arts-dance-movement',
  whoWeHelpRecreationFacilities = '/who-we-help/recreation-facilities',
  whoWeHelpOther = '/who-we-help/small-and-medium-businesses',
  whoWeHelpWhiteLabel = '/who-we-help/white-label-partners',
  loadingItem = '/loading/:item',
  payments = '/payments/:paymentStatus',
  product = '/product',
  pricing = '/pricing',
  playground = '/playground',
  facebookDemo = '/facebook-demo',
  referral = '/referral',
  referralLink = '/referral/:referralCode',
  referralsAbout = '/referrals-about',
  supportAndContact = '/support-and-contact',
}

export enum EAdminPortalClientPath {
  admin = '/admin',
  agent = `${admin}/admin-agent/:id`,
  partnerManagement = `${admin}/partner-management`,
  partnerEdit = `${admin}/partner-management/:partnerId`,
  referrals = `${admin}/admin-referrals`,
  reports = `${admin}/admin-reports`,
  templates = `${admin}/admin-templates`,
  user = `${admin}/admin-user/:id`,
  partnerCreate = `${admin}/partner-management/create`,
  promptMetadata = `${admin}/prompt-metadata`,
}

export enum EClientPath {
  login = '/login',
  register = '/register',
  forgotPassword = '/forgot-password',
  termsOfUse = '/terms-of-use',
  overview = '/overview',

  onboardingBase = '/onboarding',
  demoBase = '/demo',

  partialBasicInfo = '/basic-info',
  partialCreatingLibby = '/creating-assistant',
  partialTryItOut = '/try-it-out',

  onboardingBasicInfo = `${onboardingBase}${partialBasicInfo}`,
  onboardingCreatingLibby = `${onboardingBase}${partialCreatingLibby}`,
  onboardingTryItOut = `${onboardingBase}${partialTryItOut}`,

  demoBasicInfo = `${demoBase}${partialBasicInfo}`,
  demoCreatingLibby = `${demoBase}${partialCreatingLibby}`,
  demoTryItOut = `${demoBase}${partialTryItOut}`,

  settingsBase = '/settings',
  settingsBasicInfo = `${settingsBase}/basic-info`,
  settingsCreatingLibby = `${settingsBase}/creating-assistant`, // todo: check if this is used anywhere, maybe it's not but maybe it should.
  settingsConvoOptions = `${settingsBase}/agent-preferences`,
  settingsKnowledge = `${settingsBase}/knowledge`,
  settingsIndividualKnowledgeSet = `${settingsKnowledge}/:knowledgeSetId`,
  settingsChatbot = `${settingsBase}/chatbot`,
  settingsEmail = `${settingsBase}/email`,
  settingsPhoneText = `${settingsBase}/phone-text`,
  settingsNotifications = `${settingsBase}/notifications`,
  settingsEscalations = `${settingsBase}/escalations`,

  inbox = '/inbox',
  inboxMessage = '/inbox/:contactId',
  contacts = '/contacts',
  contact = '/contacts/:contactId',
  contactConversation = '/contacts/:contactId/:conversationId',
  campaignsBase = '/campaigns',
  campaignList = `${campaignsBase}`,
  campaignCreateEdit = `${campaignsBase}/campaign/:id`,
  campaignDetails = `${campaignCreateEdit}/details`,
  campaignContacts = `${campaignCreateEdit}/contacts`,
  campaignResults = `${campaignCreateEdit}/results`,
  reports = '/reports',
  privacyPolicy = '/privacy-policy',
  billing = '/billing',
  anything = '*',
  chatBase = '/chat',
  chat = `${chatBase}/:agentId`,
  legacyChat = `${chatBase}/legacy/:legacyChatbotId`,

  integrations = '/integrations-help',
  referralsInfo = '/referrals-info',
  referralsTerms = '/referrals-terms',
  learnMore = '/learnmore',
  support = '/support',
  help247 = '/help247',
  partnerAuth = '/auth',
  account = '/account',
  partnerAdmin = '/partner-admin',
  partnerGeneralSettings = `${partnerAdmin}/general-settings`,
  partnerBranding = `${partnerAdmin}/branding`,
  partnerPayments = `${partnerAdmin}/payments`,
  partnerAdminUserManagement = `${partnerAdmin}/user-management`,
  partnerAdminReports = `${partnerAdmin}/reports`,
  partnerAdminUserManagementById = `${partnerAdminUserManagement}/:userId`,

  manageAssistants = '/manage-assistants',

  scenariosBase = '/scenarios',
  manageScenarios = `${scenariosBase}`,
  scenarioCreateEdit = `${scenariosBase}/scenario/:scenarioId`,

  scenarioActionBase = `${scenariosBase}/actions`,
  scenarioActionCreateEdit = `${scenarioActionBase}/:actionId`,
  users = '/users',

  liveTransfersScenarios = '/live-transfers-scenarios',
  home = '/',
}

export enum EServerPath {
  users = '/users',
  usersInvite = '/users/invite',
  user = '/users/:userId',
  userCognito = '/users/cognito/:cognitoUid',
  orgs = '/orgs',
  agents = '/agents',
  webScrapeStatus = '/agents/loadstatus/:agentId',
  agent = '/agents/:agentId',
  images = '/agents/images/:agentId',
  agentEmailSignature = '/agents/signature/:agentId',
  templates = '/templates',
  template = '/templates/:templateId',
  qualifications = '/qualifications',
  inbox = '/contacts/inbox',
  inboxMessages = '/contacts/inbox/messages',
  contacts = '/contacts',
  contactsForReports = '/contacts/reports',
  contact = '/contacts/:contactId',
  contactsBatchDelete = '/contacts/batchDelete',
  notes = '/notes',
  note = '/notes/:id',
  emailAddresses = '/emailaddresses',
  emailAddressesAssignments = '/emailaddresses/assignments',
  conversations = '/conversations',
  conversation = '/conversations/:conversationId',
  conversationFeed = '/conversations/feed',
  phoneNumber = '/numbers',
  recordIntro = '/recordintro',
  recordIntroBlendAudio = `${recordIntro}/blendaudio`,
  adminAgents = '/admin/agents',
  adminUsers = '/admin/users',
  adminActiveUsers = '/admin/activeUsers',
  adminConversations = '/admin/conversations',
  adminUserFromOrg = '/admin/org/:orgId',
  adminDeleteUser = '/admin/data-cleanup',
  adminPromptMetadata = '/admin/prompt-metadata',
  adminPromptMetadataDelete = `${adminPromptMetadata}/:id`,
  chatbotSettings = '/agents/chatsettings',
  chat = '/chat',
  endChatConversation = '/chat/endconversation/:conversationId',
  allReferrals = '/orgs/getAllReferrals',
  referralCountForOrg = '/orgs/getReferralCountForOrg/:id',
  updateReferralCode = '/orgs/updateReferralCode/:orgId',
  getRefferalUICustomization = '/orgs/getReferralUICustomization',
  updateReferredByCode = '/orgs/updateReferredByCode/:orgId',
  organization = '/orgs/:id',
  trialDaysLeft = '/orgs/:organizationId/freeTrialDaysLeft',
  checkout = '/stripe/checkout',
  billing = '/stripe/customer-portal',
  partnersByOrgs = '/orgs/partners',
  partners = '/partners',
  partner = '/partners/:id',
  partnerAdminReports = '/partners/:partnerId/report',
  partnerAdminUsers = '/partners/:partnerId/users',
  partnerAdminUsersByOrganization = '/partners/:partnerId/organizations/:organizationId/users',
  partnerAdminOrganizations = '/partners/:partnerId/organizations',
  partnerAdminPricingOptions = 'partners/:partnerId/pricing-options',
  updateUserTier = '/partners/:partnerId/organizations/:organizationId',
  credentials = '/credentials',
  campaigns = '/campaigns',
  campaign = `${campaigns}/:id`,
  campaignExecute = `${campaign}/execute`,
  campaignContacts = `${campaign}/contacts`,
  campaignContact = `${campaign}/contacts/:campaignContactId`,
  campaignConversations = `${campaign}/conversations`,
  scenarios = '/scenarios',
  scenario = '/scenarios/:id',
  scenarioAgents = '/scenarios/:scenarioId/agents',
  scenarioAgentsForAdmin = '/scenarios/:scenarioId/agents/all',
  scenarioAgent = '/scenarios/:scenarioId/agents/:agentId',
  actions = '/actions',
  action = '/actions/:id',
  additionalVoices = '/templates/voices',
  adminCheckout = '/stripe/admin-checkout',
  agentPhoneSettings = '/agents/phone-settings/:agentId',
  liveTransferScenarios = '/live-transfer-scenarios',
  liveTransferScenario = `${liveTransferScenarios}/:id`,
  knowledgeSets = '/knowledge-sets',
  knowledgeSet = `${knowledgeSets}/:knowledgeSetId`,
  knowledgeSetItems = `${knowledgeSet}/items`,
  knowledgeSetItemsBatch = `${knowledgeSetItems}/batch`,
  knowledgeSetItemsBatchDelete = `${knowledgeSetItemsBatch}/delete`,
  knowledgeSetClone = `${knowledgeSet}/clone`,
  knowledgeSetItem = `${knowledgeSetItems}/:knowledgeSetItemId`,
}

export enum EHttpErrorName {
  userNotFound = 'USER_NOT_FOUND',
  conversationNotFound = 'CONVERSATION_NOT_FOUND',
  agentNotFound = 'AGENT_NOT_FOUND',
  contactNotFound = 'CONTACT_NOT_FOUND',
}
